/* eslint-disable no-console */
/* eslint-disable max-len */
import { Tooltip } from '@mui/material';

function SelectInput(props) {
  const { id, className, value, disabled, onBlur, onClick, onFocus, SelOption, onContextMenu, onKeyDown, onChange } = props;

  return (
    <Tooltip title={(value.length > 1) ? value : ''}>
      <select
        id={id}
        className={className}
        value={value}
        disabled={disabled}
        onBlur={onBlur}
        onClick={onClick}
        onChange={onChange}
        onFocus={onFocus}
        onContextMenu={onContextMenu}
        onKeyDown={onKeyDown}
      >
        {SelOption.map((options, key) => {
          return (
            <option
              value={options}
              key={key}>{options}</option>);
        })}
      </select>
    </Tooltip>
  );
}

export default SelectInput;